// Common Settings
export const PROGRAM_VIEW = 'displayType';
export const PROGRAM_VIEWS = 'scheduleViews';
export const FONT = 'font';
export const SCHEDULE_ELEMENTS_ROUNDING  = 'elementsRoundingSize';
export const BACKGROUND_ADDITIONAL_OPACITY = 'backgroundAdditionalOpacityPercent';
export const BACKGROUND_ADDITIONAL_BLUR = 'backgroundAdditionalBlurSize';
export const BACKGROUND_CARD_OPACITY = 'backgroundCardOpacityPercent';
export const BACKGROUND_CARD_BLUR = 'backgroundCardBlurSize';
export const SHEDULE_CARD_TEXT_COLOR = 'cardTextColor';
export const ADDITIONAL_COLOR = 'additionalColor';
export const SCHEDULE_DAYS_VIEW = 'daysView';
export const SCHEDULE_HALLS_VIEW = 'hallsView';
export const SCHEDULE_COMMON_ADD_TO_CALENDAR = 'showCommonAddToCalendar';
export const SCHEDULE_SHOW_SEARCH = 'showSearch';
export const SCHEDULE_SHOW_FORMAT_FILTER = 'showFormatFilter';
export const SCHEDULE_SHOW_TAGS_FILTER = 'showTagsFilter';
export const SCHEDULE_COMMON_SHOW_MODALS = 'showModals';
export const DELAY_TEXT_COLOR = 'delayTextColor';
export const DELAY_BACKGROUND_COLOR = 'delayBackgroundColor';
export const SCHEDULE_SHOW_PDF_EXPORT = 'showPdfExport';
export const SCHEDULE_SHOW_WATCH_RECORDING = 'showWatchRecordButton';
export const SCHEDULE_DISPLAY_EPISODE_RECORD = 'displayEpisodeRecord';
export const FONT_SIZE_GENERAL = 'fontSizeGeneral';
export const SCHEDULE_SHOW_ASK_QUESTION = 'showAskQuestionButton';

// Card View Tile
export const SCHEDULE_TILE_INTERVALS = 'intervals';
export const SCHEDULE_TILE_SHOW_MEMBERS_PHOTO = 'showTileMembersPhoto';
export const SCHEDULE_TILE_SHOW_MEMBERS_NAME = 'showTileMembersName';
export const SCHEDULE_TILE_SHOW_PARTICIPATION_TYPE = 'showTileParticipationType';
export const SCHEDULE_TILE_SHOW_STATUS = 'showTileStatus';
export const SCHEDULE_TILE_ADD_TO_CALENDAR = 'showTileAddToCalendar';
export const SCHEDULE_TILE_PHOTO_ROUNDING = 'tilePhotoRoundingSize';

// Card View Grid
export const SCHEDULE_GRID_CARD_HIEGHT = 'gridCardHeightSize';
export const SCHEDULE_GRID_SHOW_MEMBERS_PHOTO = 'showGridMembersPhoto';
export const SCHEDULE_GRID_SHOW_MEMBERS_NAME = 'showGridMembersName';
export const SCHEDULE_GRID_SHOW_PARTICIPATION_TYPE = 'showGridParticipationType';
export const SCHEDULE_GRID_SHOW_STATUS = 'showGridStatus';
export const SCHEDULE_GRID_ADD_TO_CALENDAR = 'showGridAddToCalendar';
export const SCHEDULE_GRID_STRIPES = 'showGridStripes';

// Card View List
export const SCHEDULE_LIST_SHOW_DESCRIPTION = 'showDescription';
export const SCHEDULE_LIST_SHOW_MEMBERS_PHOTO = 'showListMembersPhoto';
export const SCHEDULE_LIST_SHOW_MEMBERS_NAME = 'showListMembersName';
export const SCHEDULE_LIST_SHOW_PARTICIPATION_TYPE = 'showListParticipationType';
export const SCHEDULE_LIST_SHOW_STATUS = 'showListStatus';
export const SCHEDULE_LIST_ADD_TO_CALENDAR = 'listListAddToCalendar';
export const SCHEDULE_LIST_PHOTO_ROUNDING = 'listPhotoRoundingSize';

// Pop Up Episode
export const SCHEDULE_SHOW_EPISODE_POPUP = 'showEpisodePopup';
export const SCHEDULE_EPISODE_POPUP_OPACITY = 'popupOpacityPercent';
export const SCHEDULE_EPISODE_POPUP_BLUR = 'popupBlurSize';
export const SCHEDULE_EPISODE_POPUP_SHOW_FORMAT = 'showEpisodePopupFormat';
export const SCHEDULE_EPISODE_POPUP_SHOW_STATUS = 'showEpisodePopupStatus';
export const SCHEDULE_EPISODE_POPUP_ADD_TO_CALENDAR = 'showEpisodePopupAddToCalendar';
export const SCHEDULE_EPISODE_POPUP_WATCH_EPISODE = 'showEpisodePopupWatchEpisode';
export const SCHEDULE_EPISODE_POPUP_BACKGROUND_COLOR = 'popupBackgroundColor';
export const SCHEDULE_EPISODE_POPUP_TEXT_COLOR = 'popupTextColor';

// Pop Up Member
export const SCHEDULE_SHOW_MEMBER_POPUP = 'showMemberPopup';
export const SCHEDULE_MEMBER_POPUP_SHOW_FORMAT = 'showMemberPopupFormat';
export const SCHEDULE_MEMBER_POPUP_SHOW_STATUS = 'showMemberPopupStatus';
export const SCHEDULE_MEMBER_POPUP_ADD_TO_CALENDAR = 'showMemberPopupAddToCalendar';

export const SETTINGS_VIEW_TYPES = {
    lines: 'Список',
    tiles: 'Плитка',
    grid: 'Сетка',
};
